export function nfcSupported() {
  return typeof window !== 'undefined' && 'NDEFReader' in window;
}

/** Graba una URL NDEF (el iPhone/Android del cliente la abre al acercar el teléfono). Solo Chrome Android. */
export async function writeNfcUrl(url, { signal } = {}) {
  const Reader = window.NDEFReader;
  if (!Reader) {
    const err = new Error('nfc_no_soportado');
    err.code = 'nfc_no_soportado';
    throw err;
  }
  const ndef = new Reader();
  await ndef.write(
    {
      records: [{ recordType: 'url', data: String(url) }],
    },
    { signal },
  );
}
